import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { useCart } from "@/context/CartContext";
import { fileUrl, formatBRL } from "@/lib/api";
import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function CartDrawer() {
  const { items, open, setOpen, updateQty, remove, subtotal } = useCart();
  const nav = useNavigate();

  return (
    <Sheet open={open} onOpenChange={setOpen}>
      <SheetContent side="right" className="w-full sm:max-w-md bg-[#0A0A0C] border-l border-white/10 text-white p-0 flex flex-col">
        <SheetHeader className="px-6 py-5 border-b border-white/10">
          <SheetTitle className="font-display tracking-tight text-xl text-white">Seu carrinho</SheetTitle>
        </SheetHeader>
        <div className="flex-1 overflow-y-auto px-6 py-5 space-y-5">
          {items.length === 0 && (
            <div className="text-center text-zinc-400 py-20" data-testid="cart-empty">
              <p className="font-display text-lg">Carrinho vazio</p>
              <p className="text-sm mt-2">Adicione produtos para começar.</p>
            </div>
          )}
          {items.map((it) => {
            const key = `${it.product_id}|${it.size || ""}|${it.color || ""}`;
            return (
              <div key={key} className="flex gap-4" data-testid={`cart-item-${it.product_id}`}>
                <Link to={`/produto/${it.product_id}`} onClick={() => setOpen(false)} className="shrink-0 h-24 w-20 bg-black overflow-hidden border border-white/10">
                  {it.image ? <img src={fileUrl(it.image)} alt={it.name} className="w-full h-full object-cover" /> : null}
                </Link>
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm font-medium truncate">{it.name}</h4>
                  <div className="text-xs text-zinc-500 mt-1">
                    {it.size && <span>Tam: {it.size}</span>}
                    {it.size && it.color && <span> · </span>}
                    {it.color && <span>Cor: {it.color}</span>}
                  </div>
                  <div className="flex items-center gap-3 mt-3">
                    <div className="flex items-center border border-white/15">
                      <button onClick={() => updateQty(key, it.quantity - 1)} className="h-7 w-7 grid place-items-center hover:bg-white/5" data-testid={`cart-dec-${it.product_id}`}><Minus size={13} /></button>
                      <span className="min-w-6 text-center text-sm">{it.quantity}</span>
                      <button onClick={() => updateQty(key, it.quantity + 1)} className="h-7 w-7 grid place-items-center hover:bg-white/5" data-testid={`cart-inc-${it.product_id}`}><Plus size={13} /></button>
                    </div>
                    <button onClick={() => remove(key)} className="text-zinc-500 hover:text-white" data-testid={`cart-remove-${it.product_id}`}><Trash2 size={14} /></button>
                  </div>
                </div>
                <div className="text-sm font-display">{formatBRL(it.price * it.quantity)}</div>
              </div>
            );
          })}
        </div>
        <div className="border-t border-white/10 p-6 space-y-4">
          <div className="flex justify-between text-sm">
            <span className="text-zinc-400">Subtotal</span>
            <span className="font-display text-white" data-testid="cart-subtotal">{formatBRL(subtotal)}</span>
          </div>
          <p className="text-xs text-zinc-500">Frete calculado no checkout.</p>
          <Button
            data-testid="cart-go-checkout"
            onClick={() => { setOpen(false); nav("/checkout"); }}
            disabled={items.length === 0}
            className="w-full bg-white text-black hover:bg-zinc-200 h-12 font-semibold tracking-wide"
          >
            Finalizar compra
          </Button>
          <Button variant="outline" onClick={() => { setOpen(false); nav("/carrinho"); }} className="w-full bg-transparent border-white/15 text-white hover:bg-white/5 h-11">
            Ver carrinho
          </Button>
        </div>
      </SheetContent>
    </Sheet>
  );
}
